import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';

import { OriginSelectorComponent } from './origin-selector/origin-selector.component';
import { GroupingComponent } from './grouping/grouping.component';
import { GroupsListComponent } from './grouping/groups-list/groups-list.component';
import { GroupEditComponent } from './grouping/group-edit/group-edit.component';
import { SelectListComponent } from './grouping/group-edit/select-list/select-list.component';
import { ProviderFilesComponent } from './provider-files/provider-files.component';
import { SimulationFilesComponent } from './simulation-files/simulation-files.component';
import { ConfigFilesListComponent } from './config-files-list/config-files-list.component';
import { ParametersComponent } from './parameters.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        RouterModule,
        FormsModule
    ],
    declarations: [
        OriginSelectorComponent,
        GroupingComponent,
        GroupsListComponent,
        GroupEditComponent,
        SelectListComponent,
        ProviderFilesComponent,
        SimulationFilesComponent,
        ConfigFilesListComponent,
        ParametersComponent
    ]
})
export class ParametersModule { }
